export default __webpack_public_path__ + "static/media/2_carousel.c0f58a92.jpeg";